import { getIsQa } from '../constants/apiEnvironments';
import { getQueryParam } from '../routing/getQueryParam';
export const getAppleAuthClient = () => {
  return window.AppleID;
};
export const getAppleClientId = () => {
  const clientId = getIsQa() ? 'com.hubspot.apple-sign-in-qa' : 'com.hubspot.apple-sign-in-prod';
  return clientId;
};
export const shouldShowApple = () => {
  return getQueryParam('should_show_apple') === 'true' && getIsQa();
};
export const getNameFromAppleUser = user => {
  let firstName = '';
  let lastName = '';

  if (user && user.name) {
    const {
      name
    } = user;
    firstName = name.firstName || '';
    lastName = name.lastName || '';
  }

  return {
    firstName,
    lastName
  };
};